import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { ArrowIcon as n } from "../../../assets/svgs/ArrowIcon.js";
import { CloseIcon as d } from "../../../assets/svgs/CloseIcon.js";
const s = ({ sendEvent: l, handleCloseAction: r }) => /* @__PURE__ */ e("header", { children: [
  /* @__PURE__ */ e("div", { className: "return", children: [
    /* @__PURE__ */ o(n, { rotate: "Left", color: "var(--color-support-links)" }),
    /* @__PURE__ */ o("a", { onClick: r, children: "Cadastro Clube de Fidelidade" })
  ] }),
  /* @__PURE__ */ o("button", { onClick: () => {
    l("Fechou o modal no X"), r();
  }, children: /* @__PURE__ */ o(d, {}) })
] });
export {
  s as Header
};
